import React from 'react';
import Chart from 'react-apexcharts';

const chartTypes = ["bar", "line", "area", "pie", "radar", "scatter", "bubble"];

export default function GraphChart({
  header = "Report",
  data = { series: [], options: {} },
  height = 300,
  chartType = "bar", // Default chart type
}) {
  // Ensure chartType is valid
  const validatedChartType = chartTypes.includes(chartType) ? chartType : "bar";

  // Fallback defaults for options and series
  const defaultOptions = {
    chart: {
      id: 'default-chart',
      animations: { enabled: false },
    },
    xaxis: { categories: [] },
  };

  const defaultSeries = [{ name: "Sample Series", data: [] }];

  const chartOptions = data?.options || defaultOptions;
  const chartSeries = data?.series?.length > 0 ? data.series : defaultSeries;

  return (
    <div className="graph-chart-content form-control">
      <div className="row align-items-center mb-3">
        <div className="col-sm-6">
          <h6>{header}</h6>
        </div>
        <div className="col-sm-6 text-end">
          <span className="badge bg-primary">{validatedChartType.toUpperCase()}</span>
        </div>
      </div>
      <Chart
        options={chartOptions}
        series={chartSeries}
        type={validatedChartType}
        height={height}
      />
    </div>
  );
}
